import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Styles from './Slider.styles';

const context = classNames.bind(Styles);

export const SliderTick = ({
  active,
  format,
  tick,
}) => {
  const indicatorDigits = tick.value.toString().length;

  return (
    <div>
      <div
        className={context('tick')}
        style={{
          left: `${tick.percent}%`,
        }}
      />
      <div
        className={context('tick-indicator', { active })}
        style={{
          left: `${tick.percent}%`,
          marginLeft: `-${indicatorDigits * 0.2}em`,
        }}
      >
        {format(tick.value)}
      </div>
    </div>
  );
};

SliderTick.propTypes = {
  active: PropTypes.bool,
  format: PropTypes.func,
  tick: PropTypes.shape({
    percent: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }).isRequired,
};

SliderTick.defaultProps = {
  active: false,
  format: (id) => id,
};

export default SliderTick;
